import * as React from 'react';
import { UitkToast } from 'uitk-react-toast';

interface IToastProviderProps {
  children: React.ReactNode;
}

interface IToastParam {
  show: boolean;
  message: string;
}

interface IContextType {
  showToastSettings?: (args: IToastParam) => void;
}

const ToastContext = React.createContext<IContextType>({});

const ToastProvider: React.FunctionComponent<IToastProviderProps> = ({ children }) => {
  const [showToast, setShowToast] = React.useState(false);
  const [toastMessage, setToastMessage] = React.useState('');

  const showToastSettings = ({ show, message }) => {
    setShowToast(show);
    setToastMessage(message);
  };

  const handleDismiss = () => {
    setShowToast(false);
    setToastMessage('');
  };

  return (
    <ToastContext.Provider value={{ showToastSettings }}>
      <UitkToast show={showToast} onDismiss={handleDismiss}>
        {toastMessage}
      </UitkToast>
      {children}
    </ToastContext.Provider>
  );
};

const ToastConsumer = ToastContext.Consumer;

export { ToastConsumer, ToastProvider, IContextType };
export default ToastContext;
